import { BuildingCircularSiteMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const List = [
  {
    fileStoreId: "a6b97195-12c3-419e-97cd-24dc8806b437",
    label: "DG(BLDG)'s Circular No. 10 of 2019-20",
    date: "12/03/2020",
    subject:
      "Online system for Commencement and Completion Certificate Circular No.10 of 2019-20",
  },
  {
    fileStoreId: "aff0a745-7e63-4f83-810f-9fce527e6e23",
    label: "DG(BLDG)'s Circular No. 9 of 2019-20",
    date: "28/12/2019",
    subject:
      "Deed of gift for corner splay, strip of land to send to Engineering dept and Survey dept Circular No.9 of 2019-20",
  },
  {
    fileStoreId: "d1e5e083-58a2-4fec-ab43-9eae72ae2213",
    label: "DG(BLDG)'s Circular No. 8 of 2019-20",
    date: "23/12/2019",
    subject:
      "Salient Environment Conditions to incorporate in building plan Circular No.8 of 2019-20",
  },
  {
    fileStoreId: "daafe27b-961b-4293-a7ac-019d20289b16",
    label: "DG(BLDG)'s Circular No. 7 of 2019-20",
    date: "	01/11/2019",
    subject:
      "ROR-BLLRO mutation for land area upto 210 SqM in the added area Circular No.7 of 2019-20",
  },

  {
    fileStoreId: "903797e1-7f26-4c1a-bed6-ef3fc2a64d34",
    label: "DG(BLDG)'s Circular No. 6 of 2019-20",
    date: "24/08/2019",
    subject:
      "Minor repair, reflooring of existing damaged roof in thika property Circular No. 6 of 2019-20",
  },

  {
    fileStoreId: "a23d1b1c-be9d-43c4-9215-6524bd621bec",
    label: "DG(BLDG)'s Circular No. 4 of 2019-20",
    date: "	05/08/2019",
    subject:
      "One additional floor on residential building Circular No. 4 of 2019-20",
  },

  {
    fileStoreId: "ed2e2d78-9990-42c0-aeed-c088b1d0bc25",
    label: "DG(BLDG)'s Circular No. 3 of 2019-20",
    date: "29/07/2019",
    subject: "Document and display board at site Circular No. 3 of 2019-20",
  },
  {
    fileStoreId: "04773a46-d2e6-4d08-a725-953607717c5d",
    label: "DG(BLDG)'s Circular No. 2 of 2019-20",
    date: "02/07/2019",
    subject:
      "Format of undertaking in rule 142 for MC Circular 132 dated 20/02/2019 Circular No. 2 of 2019-20",
  },
];

const Building_Sanction_Circular_2019_20 = () => (
  <TableStructure
    list={List}
    columnNo={3}
    leftMenuList={BuildingCircularSiteMenuList}
    title="Circular :: 2019-20"
    longMenuList={true}
  />
);

export default Building_Sanction_Circular_2019_20;
